import styled from 'styled-components';

export const Back = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.49);
`;

export const Modal = styled.div`
  width: 50%;
  max-width: 360px;
  min-width: 300px;
  background: #161e23;
  color: #e6eaec;
  border: 1px solid #3d4952;
  position: fixed;
  top: 50%;
  z-index: 100001;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6);
  border-radius: 14px;
  overflow: hidden;
`;

export const Content = styled.div`
  .timepicker-modal .am-pm-input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .text-shadow {
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.13);
  }

  .timepicker-modal .mask {
    width: 100%;
    height: 100%;
  }
`;
